import React from "react";

export default function PropertyTableSkeleton() {
  return (
    <div className="mt-3 flex flex-col">
      <div className="inline-block min-w-full align-middle">
        <div className=" shadow-sm ring-1 ring-black ring-opacity-5 rounded-lg overflow-x-auto">
          <table className="min-w-full sm:divide-y sm:divide-gray-300">
            <thead className="hidden bg-gray-50 sm:table-header-group">
              <tr>
                <th className="px-12 py-3 text-xs font-medium tracking-wide text-left text-gray-500 uppercase sm:pl-6"></th>
                <th className="px-3 py-3 text-xs font-medium tracking-wide text-left text-gray-500 uppercase whitespace-nowrap">
                  Tipo de propiedad
                </th>
                <th className="px-3 py-3 text-xs font-medium tracking-wide text-center text-gray-500 uppercase">
                  Estatus
                </th>
                <th className="px-3 py-3 text-xs font-medium tracking-wide text-left text-gray-500 uppercase">
                  Promotor
                </th>
                <th className="px-3 py-3 text-xs font-medium tracking-wide text-left text-gray-500 uppercase">
                  Precio
                </th>
                <th className="px-3 py-3 text-xs font-medium tracking-wide text-left text-gray-500 uppercase">
                  Comisión compartida
                </th>
                <th className="px-3 py-3 text-xs font-medium tracking-wide text-left text-gray-500 uppercase">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="bg-white animate-pulse">
              {[...Array(5)].map((_, i) => (
                <tr key={i} className={i % 2 === 0 ? undefined : "bg-gray-50"}>
                  <td className="flex items-center gap-3 py-2 align-middle px-2">
                    <div className="h-[100px] w-[100px] md:h-[120px] md:w-[120px] rounded-lg bg-gray-300" />
                  </td>
                  <td className="px-1 py-4 sm:px-3">
                    <div className="flex gap-1">
                      <div className="flex flex-col space-y-2">
                        <div className="h-4 w-16 bg-gray-300 rounded" />
                        <div className="h-4 w-24 bg-gray-300 rounded" />
                      </div>
                    </div>
                  </td>
                  <td className="px-3 py-4">
                    <div className="h-5 w-20 bg-gray-300 rounded-md sm:ml-3" />
                  </td>
                  <td className="px-3 py-4">
                    <div className="h-4 w-24 bg-gray-300 rounded sm:ml-3" />
                  </td>
                  <td className="hidden sm:table-cell px-3 py-4">
                    <div className="flex flex-col space-y-2">
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                      <div className="h-4 w-24 bg-gray-300 rounded" />
                    </div>
                  </td>
                  <td className="px-3 py-4">
                    <div className="h-4 w-24 bg-gray-300 rounded sm:ml-3" />
                  </td>
                  <td className="hidden sm:table-cell px-3 py-4">
                    <div className="flex flex-row space-x-6">
                      <div className="h-5 w-5 bg-gray-300 rounded" />
                      <div className="h-5 w-5 bg-gray-300 rounded" />
                      <div className="h-5 w-5 bg-gray-300 rounded" />
                    </div>
                  </td>
                  <td className="relative py-3 pl-3 pr-4 sm:pr-6">
                    <div className="h-5 w-16 bg-gray-300 rounded" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
